<img [businessImage]="product.productImageUrl" alt="Food" class="food-preview" />
<div class="dish-inner" style="cursor: pointer;">
  <div class="dish-info-wrap">
    <h4 class="dish-name">{{product.title}}</h4>
    <span class="lines"></span>
    <h4 class="dish-price">{{currencySymbol + ' ' + product.price}}</h4>
  </div>
  <p class="dish-info">{{product.description}}</p>
</div>
<div class="cta" *ngIf="showButtons">
  <app-button
    [btnText]="'Edit'"
    [btnTitle]="'Edit'"
    [btnCss]="'btn btn-primary'"
    (onBtnClick)="
      openMenuItemModal(
        menuComponent.menuModalTemplate,
        'project-modal edit-food-menu-modal'
      , '', product.id)
    "
  ></app-button>
  <app-button
    [btnText]="'Delete'"
    [btnTitle]="'Delete'"
    [btnCss]="'btn btn-primary'"
    (onBtnClick)="
      openMenuItemModal(
        deleteConfirmationPopupComponent.deleteConfirmationTemplate,
        'delete-menu-item-modal',
        'sm', product.id)
    "
  ></app-button>
</div>
<app-delete-confirmation-popup #deleteTemplate [id]="product.id" [dishName]="product.title" [imageId]="product.productImageId" (menuDeleted)="menuDeleted($event)"></app-delete-confirmation-popup>
<app-menu #menu [id]="product.id" [types]="menuTypes" [businessPartnerId]="businessPartnerId" (menuUpdated)="menuUpdated($event)"></app-menu>
